var exports = {
  "k": "x31de4314--de6207--container",
};

module.exports = exports;
